import React, {h, Component} from 'preact';

export default class SellHomeTypeStep extends Component {
    chooseHomeType(homeType) {
        let currentStep = window.SPLIT_CONTACT_FORM_STEP ? 'SELL_CONTACT_FORM1' : 'SELL_CONTACT_FORM';
    
        this.props.parent.setState({
            homeType: homeType,
            currentStep
        });
    }

    componentDidMount() {
        trackEvent('Flow', 'SellRequest', 'sellV3Step0', {
            abTestWHYVersion: window.abTestWHYVersion
        })
            .withOptimizely()
            .withGA();

        trackEvent('Flow', 'SellRequest', 'sellerRequestStep3PageLoad', {
            abTestFontVersion: $('body.flow-with-larger-font').is(':visible') ? 'B' : 'A'
        })
            .withGA()
            .withOptimizely();
    }

    render() {
        return (
            <div className="flow-step">
                <div className="flow-step-text hidden-xs">
                    <img className="icon-desktop" src={global.imageBaseUrl + 'buysell/svg/compare-proposals.svg'} />
                    <div>
                        Receive commission quotes from top listing agents in{' '}
                        {this.props.city ? this.props.city : this.props.location}.
                    </div>
                </div>

                <div className="flow-step-header-text">
                    <strong>
                        What kind of home are you looking to sell in{' '}
                        {this.props.city ? this.props.city : this.props.location}?
                    </strong>
                </div>

                <div className="option-div">
                    <div id="home-type-div">
                        <div
                            onClick={() => this.chooseHomeType('Single Family')}
                            className="choice-button sell-home-type-button">
                            <img src={global.imageBaseUrl + '/buysell/svg/single-family.svg'} />
                            <div style={{overflow: 'hidden'}}>
                                <span className="button-text">Single Family</span>
                            </div>
                        </div>
                        <div
                            onClick={() => this.chooseHomeType('Condominium')}
                            className="choice-button sell-home-type-button">
                            <img src={global.imageBaseUrl + '/buysell/svg/condominium.svg'} />
                            <div style={{overflow: 'hidden'}}>
                                <span className="button-text">Condominium</span>
                            </div>
                        </div>
                        <div
                            onClick={() => this.chooseHomeType('Townhouse')}
                            className="choice-button sell-home-type-button">
                            <img src={global.imageBaseUrl + '/buysell/svg/townhouse.svg'} />
                            <div style={{overflow: 'hidden'}}>
                                <span className="button-text">Townhouse</span>
                            </div>
                        </div>
                        <div
                            onClick={() => this.chooseHomeType('Multi-Family')}
                            className="choice-button sell-home-type-button">
                            <img src={global.imageBaseUrl + '/buysell/svg/single-family.svg'} />
                            <div style={{overflow: 'hidden'}}>
                                <span className="button-text">Multi-Family</span>
                            </div>
                        </div>
                        <div
                            onClick={() => this.chooseHomeType('Land')}
                            className="choice-button sell-home-type-button">
                            <img src={global.imageBaseUrl + '/buysell/svg/vacant-lot.svg'} />
                            <div style={{overflow: 'hidden'}}>
                                <span className="button-text">Vacant Lot/Other</span>
                            </div>
                        </div>
                        <div
                            onClick={() => this.chooseHomeType('Commercial')}
                            className="choice-button sell-home-type-button">
                            <img src={global.imageBaseUrl + 'buysell/svg/commercial.svg'} />
                            <div style={{overflow: 'hidden'}}>
                                <span className="button-text">Commercial</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flow-spacer" />

                <div className="bottom-banner">
                    <div className="status-normal">
                        <div className="title">
                            <img src={global.imageBaseUrl + 'buysell/svg/compare-proposals.svg'} /> Compare Proposals
                        </div>
                        <div className="subtitle subtitle-large">
                            Receive commission quotes from top listing agents in {this.props.city}.
                        </div>
                    </div>
                    <div
                        className="status-normal subtitle subtitle-small"
                        style={{'font-size': '12px', 'opacity': '0.87', 'letter-spacing': '0.5px'}}>
                        Receive commission quotes from top listing agents in {this.props.city}.
                    </div>
                </div>
            </div>
        );
    }
}
